import Vue from 'vue'
import Router from 'vue-router'
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
  mode: 'history', // 去掉#，需要路由模式改为history
  routes: [{
      path: '/User',
      name: 'User',
      meta: {
        breadcrumb: ['用户管理'],
        permissions: []
      },
      component:  () => import(/* webpackChunkName: 'user' */'@/components/user/User'),
      children: [
        {
          path: 'Login',
          name: 'Login',
          component: () => import(/* webpackChunkName: 'user' */ '@/components/user/Login')
        },
        {
          path: 'Register',
          name: 'Register',
          component: () => import(/* webpackChunkName: 'user' */ '@/components/user/Register')
        },
        {
          path: 'Select',
          name: 'Select',
          component: () => import(/* webpackChunkName: 'user' */ '@/components/user/Select')
        },
        {
          path: 'RefereeLogin',
          name: 'RefereeLogin',
          component: () => import(/* webpackChunkName: 'user' */ '@/components/user/RefereeLogin')
        }
      ]
    }, {
      path: '/Grading/SectionList',
      name: 'SectionList',
      meta: {
        breadcrumb: ['考级项目'],
        permissions: []
      },
      component:  () => import(/* webpackChunkName: 'user' */'@/components/grading/SectionList')
    }, {
      path: '/Grading/RefereeScore',
      name: 'RefereeScore',
      meta: {
        breadcrumb: ['考级内容'],
        permissions: []
      },
      component:  () => import(/* webpackChunkName: 'user' */'@/components/grading/RefereeScore')
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js